import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { setRequired } from 'src/app/shared/utils';

@Component({
  selector: 'app-pagamento-fatturazione',
  templateUrl: './pagamento-fatturazione.component.html',
  styleUrls: ['./pagamento-fatturazione.component.scss']
})
export class PagamentoFatturazioneComponent implements OnInit {

  @Input() datiAnaForm!: FormGroup;
  @Input() datiFornForm!: FormGroup;

  setRequired = setRequired;
  fatturaUnica = false;

  ibanMinLength!: number | null;
  ibanMaxLength!: number | null;

  datiFattForm!: FormGroup;

  // NUOVO SVILUPPO GESTIONE ACCONTO
  mostraGestioneAcconto: boolean = false;

  // GESTIONE PACCHETTO
  mostraGestionePacchetto: boolean = false;
  pacchettiCliente?: any[] = [];

  // Lista POD Master disponibili come riferimento (solo DOM, caricata al primo render)
  podMasterOptions: { label: string; value: string }[] = [];
  filteredPodMasterOptions: Observable<{ label: string; value: string }[]> = new Observable();
  podMasterSearchControl = new FormControl('');

  constructor(public dataService: DataService, private fb: FormBuilder) {

    this.datiFattForm = this.fb.group({
      modalitaSpedizione: new FormControl('0', [Validators.required]),
      accorpaFatture: new FormControl('1', [Validators.required]),

      mails: new FormArray([
        new FormControl('', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")])
      ]),

      tipoIndirizzoCart: new FormControl('0'),

      sdi: new FormControl(''),
      pec: new FormControl('', [Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),

      titolareConto: new FormGroup({
        nome: new FormControl(''),
        cognome: new FormControl(''),
        codiceFiscale: new FormControl(''),
        piva: new FormControl(''),
        ragioneSociale: new FormControl('')
      }),

      // banca: new FormControl(),
      iban: new FormControl(''),

      sottoscrittore: new FormGroup({
        nome: new FormControl(''),
        cognome: new FormControl(''),
        codiceFiscale: new FormControl(''),
      }),

      modalitaPagamento: new FormControl(),
      indirizzo: new FormGroup({
        toponimo: new FormControl(''),
        indirizzo: new FormControl(''),
        civico: new FormControl(''),
        comune: new FormControl(''),
        cap: new FormControl(''),
        provincia: new FormControl(''),
        // presso: new FormControl(''),
      }),

      // POD Master: cancello principale che governa la visibilità di tutto.
      // Separato da gestioneAcconto perché riguarda CHI è il punto di riferimento,
      // non quanto si paga.
      podMaster: new FormGroup({
        isPodMaster: new FormControl(false),
        podMasterRiferimento: new FormControl(''),
      }),

      // Pacchetto cliente (kWh): visibile se isPodMaster=true, prodotto EE, aumix=SI
      gestionePacchetto: new FormGroup({
        pacchettoCliente: new FormControl(null),
        accontoBenvenuto: new FormControl(null, [Validators.pattern(/^[0-9]+$/)]),
        ripartitoPerPod: new FormControl(false)
      }),

      // Acconto alla firma (€): visibile se isPodMaster=true e pacchetto selezionato
      gestioneAcconto: new FormGroup({
        prezzoPacchetto: new FormControl(null),
        scontoPacchetto: new FormControl(0, [Validators.min(0), Validators.max(100)]), // SVILUPPO SCONTO PACCHETTO
        importoAcconto: new FormControl(''),
        rateizzato: new FormControl(false),
        numeroRate: new FormControl(''),
        importoPerRata: new FormControl(''),
        decorrenzaDaBolletta: new FormControl(''),
      })
    })
  }

  ngOnInit(): void {

    console.log(this.datiFornForm.getRawValue())

    this.dataService._isCfStraniero$.subscribe(res => {
      this.datiFattForm.get('iban')?.clearValidators();
      this.setIbanValidators();
      this.datiFattForm.get('iban')?.updateValueAndValidity({ emitEvent: false });
    })

    if (this.dataService.prodotto?.tipo_utenza === 'DOM') {
      this.podMaster.get('isPodMaster')?.setValue(true, { emitEvent: true });

      this.podMasterSearchControl.valueChanges.subscribe(val => {
        // Resetta il form control se l'utente cancella il testo
        // (distingue tra digitazione libera e selezione da lista)
        if (!val) {
          this.podMaster.get('podMasterRiferimento')?.setValue('', { emitEvent: false });
        }
      });
      // Carica i POD Master disponibili come riferimento per i POD figli.
      // Solo DOM: per BUS isPodMaster è sempre true, il dropdown non serve mai.
      this.dataService.getPodMaster().subscribe((res: { label: string; value: string }[]) => {
        this.podMasterOptions = res;

        // Ogni volta che l'utente scrive, filtra la lista in-memory (case-insensitive)
        this.filteredPodMasterOptions = this.podMasterSearchControl.valueChanges.pipe(
          startWith(''),
          map(query => {
            const q = (query ?? '').toLowerCase();
            return this.podMasterOptions.filter(opt =>
              opt.label.toLowerCase().includes(q)
            );
          })
        );
      });
    } else {
      // Per BUS ripartitoPerPod parte a true (ma l'utente può modificarlo)
      this.gestionePacchetto.get('ripartitoPerPod')?.setValue(true, { emitEvent: false });
      // Per BUS isPodMaster è sempre true, triggeriamo il listener manualmente
      this.podMaster.get('isPodMaster')?.setValue(true, { emitEvent: true });
    }

    // GESTIONE PACCHETTO CLIENTE - carica lista e imposta listener
    if (this.dataService.prodotto?.cod_tipo_fornitura_id === 'EE') {
      this.dataService.getPacchetti().subscribe((res: any[]) => {
        this.pacchettiCliente = res;

        this.gestionePacchetto.get('pacchettoCliente')?.valueChanges.subscribe(pacchettoId => {
          if (pacchettoId) {
            const pacchetto = this.pacchettiCliente?.find(p => p.id === pacchettoId);
            if (pacchetto) {
              const accontoDefault = Math.round(pacchetto.kwh_annui / 3);
              this.gestionePacchetto.get('accontoBenvenuto')?.setValue(accontoDefault, { emitEvent: false });
              // Aggiorna il prezzo e azzera tutti i campi dipendenti
              this.gestioneAcconto.get('prezzoPacchetto')?.setValue(pacchetto.prezzo, { emitEvent: false });
              this.gestioneAcconto.get('scontoPacchetto')?.setValue(0, { emitEvent: false });
              this.gestioneAcconto.get('importoAcconto')?.setValue('', { emitEvent: false });
              this.resetCampiRateizzazione();
            }
            this.gestionePacchetto.get('accontoBenvenuto')?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/)]);
          } else {
            this.gestionePacchetto.get('accontoBenvenuto')?.setValue(null, { emitEvent: false });
            this.gestionePacchetto.get('accontoBenvenuto')?.setValidators([Validators.pattern(/^[0-9]+$/)]);
            this.gestioneAcconto.get('prezzoPacchetto')?.setValue(null, { emitEvent: false });
            this.gestioneAcconto.get('importoAcconto')?.setValue('', { emitEvent: false });
            this.gestioneAcconto.get('rateizzato')?.setValue(false, { emitEvent: false });
          }

          this.gestionePacchetto.get('accontoBenvenuto')?.updateValueAndValidity({ emitEvent: false });
          this.aggiornaVisibilita();
        });

      });
    }

    if (this.dataService.prodotto?.tipo_utenza == 'BUS') {
      this.datiAnaForm?.get('tipoCliente')?.valueChanges.subscribe(tipo => {
        if (tipo == '0') {
          this.datiFattForm.get('sdi')!.addValidators(Validators.required);
          this.datiFattForm.get('pec')!.addValidators(Validators.required);
        } else {
          this.datiFattForm.get('sdi')!.clearValidators();
          this.datiFattForm.get('pec')!.clearValidators();
        }
        this.datiFattForm.get('sdi')!.updateValueAndValidity();
        this.datiFattForm.get('pec')!.updateValueAndValidity();
      });

      // dopo direttive di licitra il 17/12
      // this.datiFattForm.get('sdi')?.valueChanges.subscribe(val => {
      //   if(val){
      //     this.datiFattForm.get('pec')?.disable();
      //     this.datiFattForm.get('pec')?.clearValidators();
      //   } else {
      //     this.datiFattForm.get('pec')!.addValidators([Validators.required, Validators.email]);
      //   }
      // })

      // this.datiFattForm.get('pec')?.valueChanges.subscribe(val => {
      //   if(val){
      //     this.datiFattForm.get('sdi')?.disable();
      //     this.datiFattForm.get('sdi')?.clearValidators();
      //   } else {
      //     this.datiFattForm.get('sdi')!.addValidators(Validators.required);
      //   }
      // })

      this.datiAnaForm.get('aziendaCondominio')?.valueChanges.subscribe(value => {
        if (value.formaGiuridica) {
          // if(value.formaGiuridica == 'DIND'){
          //   this.datiFattForm.get('titolareConto')?.get('codiceFiscale')?.setValue(value.codiceFiscale, { emitEvent: false });
          // }
          this.datiFattForm.get('titolareConto')?.get('piva')?.patchValue(value.piva);
          this.datiFattForm.get('titolareConto')?.get('ragioneSociale')?.patchValue(value.ragioneSociale);
        }
      })

      this.datiAnaForm.get('rappLegale')?.valueChanges.subscribe(value => {
        this.datiFattForm.get('sottoscrittore')?.get('nome')?.patchValue(value.nome, { emitEvent: false });
        this.datiFattForm.get('sottoscrittore')?.get('cognome')?.patchValue(value.cognome, { emitEvent: false });
      })

    } else {
      this.datiAnaForm.get('cliente')?.valueChanges.subscribe(cliente => {
        // console.log(cliente);
        this.datiFattForm.get('titolareConto')?.get('nome')?.patchValue(cliente.nome, { emitEvent: false });
        this.datiFattForm.get('titolareConto')?.get('cognome')?.patchValue(cliente.cognome, { emitEvent: false });
        this.datiFattForm.get('sottoscrittore')?.get('nome')?.patchValue(cliente.nome, { emitEvent: false });
        this.datiFattForm.get('sottoscrittore')?.get('cognome')?.patchValue(cliente.cognome, { emitEvent: false });
        // il codice fiscale non si aggiorna per event emit false in dati anagrafici
        // this.datiFattForm.get('titolareConto')?.get('codiceFiscale')?.patchValue(cliente.codiceFiscale, { emitEvent: false });
      })
      // this.datiFattForm.get('titolareConto')?.valueChanges.subscribe(res => {
      //   this.datiFattForm.get('titolareConto')?.get('codiceFiscale')?.patchValue(res.codiceFiscale, { emitEvent: false })
      //   this.datiFattForm.get('sottoscrittore')?.get('codiceFiscale')?.patchValue(res.codiceFiscale, { emitEvent: false })
      // })
    }

    // per debug
    // this.datiFattForm.valueChanges.subscribe(_ => {
    //   for (const control in this.datiFattForm.controls) {
    //     if (this.datiFattForm.controls[control].invalid) {
    //       // console.log(control, this.datiFattForm.controls[control].errors)
    //       // console.log(control, this.datiFattForm.get(control)?.errors)
    //       if (this.datiFattForm.get(control) instanceof FormGroup) {
    //         for (let subcontrol in (this.datiFattForm.get(control) as FormGroup).controls) {
    //           // console.log(control, subcontrol, (this.datiFattForm.get(control) as FormGroup).controls[subcontrol].errors);
    //         }
    //       }
    //     }
    //   }
    // })

    // this.datiFattForm.valueChanges.subscribe(_ => {
    //   console.log(_);
    //   for (const control in this.datiFattForm.controls) {
    //     if (this.datiFattForm.controls[control] instanceof FormGroup) {
    //       for (const subcontrol in (this.datiFattForm.controls[control] as FormGroup)?.controls) {
    //         if ((this.datiFattForm.controls[control] as FormGroup).controls[subcontrol]?.invalid) {
    //           console.log(control, subcontrol, (this.datiFattForm.controls[control] as FormGroup).controls[subcontrol].errors)
    //         }
    //       }
    //     } else {
    //       if (this.datiFattForm.controls[control].invalid) {
    //         console.log(control, this.datiFattForm.controls[control].errors)
    //       }
    //     }
    //   }
    // })


    this.datiFattForm.get('modalitaSpedizione')?.valueChanges.subscribe(value => {
      if (value == '0') {
        for (let control in (this.datiFattForm.get('mails') as FormArray).controls) {
          (this.datiFattForm.get('mails') as FormArray).controls[control].setValidators(Validators.required);
          (this.datiFattForm.get('mails') as FormArray).controls[control].updateValueAndValidity({ emitEvent: false });
        }
        for (let control in (this.datiFattForm.get('indirizzo') as FormGroup).controls) {
          (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].clearValidators();
          (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
        }
      } else {
        for (let control in (this.datiFattForm.get('mails') as FormArray).controls) {
          (this.datiFattForm.get('mails') as FormArray).controls[control].clearValidators();
          (this.datiFattForm.get('mails') as FormArray).controls[control].updateValueAndValidity({ emitEvent: false });
        }

        this.datiFattForm.get('tipoIndirizzoCart')?.valueChanges.subscribe(value => {
          if (value == '2') {
            for (let control in (this.datiFattForm.get('indirizzo') as FormGroup).controls) {
              // if (control == 'indirizzo') {
              //   (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].addValidators(Validators.pattern(/^[a-zA-Z\s]+$/));
              // }
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].addValidators(Validators.required);
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
            }
            this.fatturaUnica = false;
          }
          else if (value == '1') {
            this.fatturaUnica = true;
            this.datiFattForm.get('accorpaFatture')?.patchValue('1');
            for (let control in (this.datiFattForm.get('indirizzo') as FormGroup).controls) {
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].clearValidators();
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
            }
          }
          else {
            for (let control in (this.datiFattForm.get('indirizzo') as FormGroup).controls) {
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].clearValidators();
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
            }
            this.fatturaUnica = false;
          }
        })
      }
    })

    this.datiFattForm.get('modalitaPagamento')?.valueChanges.subscribe(value => {
      if (value == '0') {
        for (let control in this.titolareConto.controls) {

          if (control == 'codiceFiscale') {
            this.titolareConto.controls[control].addValidators(Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i));
          }
          if (this.dataService.prodotto?.tipo_utenza == 'DOM' && control == 'ragioneSociale' || control == 'piva') {
            // pass
          } else {
            this.titolareConto.controls[control].addValidators(Validators.required);
          }
          this.titolareConto.controls[control].updateValueAndValidity({ emitEvent: false });
        }
        for (let control in this.sottoscrittore.controls) {
          this.sottoscrittore.controls[control].addValidators(Validators.required);
          if (control == 'codiceFiscale') {
            this.sottoscrittore.controls[control].addValidators(Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i));
          }
          this.sottoscrittore.controls[control].updateValueAndValidity({ emitEvent: false });
        }
        // if (this.datiAnaForm?.get('tipoCliente')?.value == '0') {
        // this.datiFattForm.get('iban')?.addValidators([Validators.required, Validators.pattern(/^[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/)]);
        this.setIbanValidators();
        this.datiFattForm.get('iban')?.updateValueAndValidity({ emitEvent: false });
        // }
      } else {
        for (let control in this.titolareConto.controls) {
          this.titolareConto.controls[control].clearValidators();
          this.titolareConto.controls[control].updateValueAndValidity({ emitEvent: false });
        }
        for (let control in this.sottoscrittore.controls) {
          this.sottoscrittore.controls[control].clearValidators();
          this.sottoscrittore.controls[control].updateValueAndValidity({ emitEvent: false });
        }
        this.datiFattForm.get('iban')?.clearValidators();
        this.datiFattForm.get('iban')?.updateValueAndValidity({ emitEvent: false });
      }
    })

    this.titolareConto?.valueChanges.subscribe(value => {
      if (value.nome || value.cognome) {
        this.titolareConto.get('nome')?.enable({ emitEvent: false });
        this.titolareConto.get('cognome')?.enable({ emitEvent: false });
        this.titolareConto.get('codiceFiscale')?.enable({ emitEvent: false });
        this.titolareConto.get('ragioneSociale')?.disable({ emitEvent: false });
        this.titolareConto.get('piva')?.disable({ emitEvent: false });
        this.titolareConto.get('ragioneSociale')?.setValue('', { emitEvent: false });
        this.titolareConto.get('piva')?.setValue('', { emitEvent: false });
      } else if (value.ragioneSociale) {
        this.titolareConto.get('nome')?.disable({ emitEvent: false });
        this.titolareConto.get('cognome')?.disable({ emitEvent: false });
        this.titolareConto.get('codiceFiscale')?.disable({ emitEvent: false });
        this.titolareConto.get('ragioneSociale')?.enable({ emitEvent: false });
        this.titolareConto.get('piva')?.enable({ emitEvent: false });
        this.titolareConto.get('nome')?.setValue('', { emitEvent: false });
        this.titolareConto.get('cognome')?.setValue('', { emitEvent: false });
      } else {
        this.titolareConto.get('nome')?.enable({ emitEvent: false });
        this.titolareConto.get('cognome')?.enable({ emitEvent: false });
        this.titolareConto.get('ragioneSociale')?.enable({ emitEvent: false });
        this.titolareConto.get('codiceFiscale')?.enable({ emitEvent: false });
        this.titolareConto.get('piva')?.enable({ emitEvent: false });
        // this.titolareConto.get('nome')?.setValue('', { emitEvent: false });
        // this.titolareConto.get('cognome')?.setValue('', { emitEvent: false });
        // this.titolareConto.get('ragioneSociale')?.setValue('', { emitEvent: false });
        // this.titolareConto.get('codiceFiscale')?.setValue('', { emitEvent: false });
        // this.titolareConto.get('piva')?.setValue('', { emitEvent: false });
      }
    })

    this.datiFattForm.get('modalitaPagamento')?.patchValue('0', { emitEvent: true });

    // Listener isPodMaster: governa validator e reset delle sezioni dipendenti
    this.podMaster.get('isPodMaster')?.valueChanges.subscribe(isPodMaster => {
      if (isPodMaster) {
        this.podMaster.get('podMasterRiferimento')?.clearValidators();
        this.podMaster.get('podMasterRiferimento')?.setValue('', { emitEvent: false });
        this.gestioneAcconto.get('importoAcconto')?.setValidators([Validators.required, Validators.min(0)]);
      } else {
        // Non è POD Master: richiede il campo riferimento e resetta le sezioni
        this.podMaster.get('podMasterRiferimento')?.setValidators([Validators.required]);
        this.gestioneAcconto.get('importoAcconto')?.clearValidators();
        this.gestioneAcconto.get('importoAcconto')?.setValue('', { emitEvent: false });
        this.gestioneAcconto.get('rateizzato')?.setValue(false, { emitEvent: false });
        this.gestionePacchetto.get('pacchettoCliente')?.setValue(null, { emitEvent: false });
        this.gestionePacchetto.get('accontoBenvenuto')?.setValue(null, { emitEvent: false });
        this.gestionePacchetto.get('accontoBenvenuto')?.clearValidators();
        this.gestionePacchetto.get('accontoBenvenuto')?.updateValueAndValidity({ emitEvent: false });
      }
      this.podMaster.get('podMasterRiferimento')?.updateValueAndValidity({ emitEvent: false });
      this.gestioneAcconto.get('importoAcconto')?.updateValueAndValidity({ emitEvent: false });
      this.aggiornaVisibilita();
    });

    // Listener per checkbox "rateizzato"
    this.gestioneAcconto.get('rateizzato')?.valueChanges.subscribe(rateizzato => {
      if (rateizzato) {
        this.gestioneAcconto.get('numeroRate')?.setValidators([Validators.required, Validators.min(1), Validators.pattern(/^\d+$/)]);
        this.gestioneAcconto.get('importoPerRata')?.setValidators([Validators.required, Validators.min(0)]);
        this.gestioneAcconto.get('decorrenzaDaBolletta')?.setValidators([Validators.required, Validators.min(1), Validators.max(12), Validators.pattern(/^\d+$/)]);
        // this.gestioneAcconto.setValidators(this.rateizzatoCoerente);

        // Auto-calcolo: numero rate -> importo per rata
        this.gestioneAcconto.get('numeroRate')?.valueChanges.subscribe(rate => {
          const saldo = this.saldoResiduo;
          const n = Number(rate);
          if (saldo !== null && n > 0) {
            const rataCalcolata = parseFloat((saldo / n).toFixed(2));
            this.gestioneAcconto.get('importoPerRata')?.setValue(rataCalcolata, { emitEvent: false });
            this.gestioneAcconto.get('importoPerRata')?.updateValueAndValidity({ emitEvent: false });
            this.gestioneAcconto.updateValueAndValidity({ emitEvent: false });
          }
        });

        // Auto-calcolo: importo per rata -> numero rate
        this.gestioneAcconto.get('importoPerRata')?.valueChanges.subscribe(rata => {
          const saldo = this.saldoResiduo;
          const r = Number(rata);
          if (saldo !== null && r > 0) {
            const rateCalcolate = Math.round(saldo / r);
            this.gestioneAcconto.get('numeroRate')?.setValue(rateCalcolate, { emitEvent: false });
            this.gestioneAcconto.get('numeroRate')?.updateValueAndValidity({ emitEvent: false });
            this.gestioneAcconto.updateValueAndValidity({ emitEvent: false });
          }
        });

      } else {
        this.gestioneAcconto.get('numeroRate')?.clearValidators();
        this.gestioneAcconto.get('importoPerRata')?.clearValidators();
        this.gestioneAcconto.get('decorrenzaDaBolletta')?.clearValidators();
        this.gestioneAcconto.get('numeroRate')?.setValue('');
        this.gestioneAcconto.get('importoPerRata')?.setValue('');
        this.gestioneAcconto.get('decorrenzaDaBolletta')?.setValue('');
        // this.gestioneAcconto.clearValidators();
      }

      this.gestioneAcconto.get('numeroRate')?.updateValueAndValidity();
      this.gestioneAcconto.get('importoPerRata')?.updateValueAndValidity();
      this.gestioneAcconto.get('decorrenzaDaBolletta')?.updateValueAndValidity();
      this.gestioneAcconto.updateValueAndValidity();
    });

    if (this.dataService.ctr_data) {
      setTimeout(() => {
        this.datiFattForm.patchValue(this.dataService.ctr_data.datiPagamento);
      }, 2000);
    }

    // this.gestioneAcconto.setValidators(this.rateizzatoCoerente);
    // this.gestioneAcconto.updateValueAndValidity();

    this.gestioneAcconto.get('scontoPacchetto')?.valueChanges.subscribe(() => {
      this.resetCampiRateizzazione();
      this.gestioneAcconto.updateValueAndValidity({ emitEvent: false });
    });

    this.gestioneAcconto.get('importoAcconto')?.valueChanges.subscribe(() => {
      this.resetCampiRateizzazione();
    });

    this.aggiornaVisibilita();
  }

  get mails() {
    return this.datiFattForm.get('mails') as FormArray;
  }

  get indirizzoForm() {
    return this.datiFattForm.get('indirizzo') as FormGroup;
  }

  get sottoscrittore() {
    return this.datiFattForm.get('sottoscrittore') as FormGroup;
  }

  get titolareConto() {
    return this.datiFattForm.get('titolareConto') as FormGroup;
  }

  get podMaster() {
    return this.datiFattForm.get('podMaster') as FormGroup;
  }

  get prezzoPacchetto(): number | null {
    return this.gestioneAcconto.get('prezzoPacchetto')?.value ?? null;
  }

  // SVILUPPO SCONTO PACCHETTO
  get prezzoPacchettoScontato(): number | null {
    const prezzo = this.prezzoPacchetto;
    if (prezzo === null) return null;
    const sconto = Number(this.gestioneAcconto.get('scontoPacchetto')?.value ?? 0);
    return parseFloat((prezzo * (1 - sconto / 100)).toFixed(2));
  }

  // get saldoResiduo(): number | null {
  //   const prezzo = this.prezzoPacchetto;
  //   const acconto = Number(this.gestioneAcconto.get('importoAcconto')?.value);
  //   if (prezzo === null || !acconto) return null;
  //   return parseFloat((prezzo - acconto).toFixed(2));
  // }
  get saldoResiduo(): number | null {
    const prezzo = this.prezzoPacchettoScontato;
    const acconto = Number(this.gestioneAcconto.get('importoAcconto')?.value);
    if (prezzo === null || !acconto) return null;
    return parseFloat((prezzo - acconto).toFixed(2));
  }

  get gestioneAcconto() {
    return this.datiFattForm.get('gestioneAcconto') as FormGroup;
  }

  get gestionePacchetto() {
    return this.datiFattForm.get('gestionePacchetto') as FormGroup;
  }

  get numeroPunti() {
    if (
      (this.dataService.datiFornitura?.get('richieste') as FormArray).length > 1
      || ((this.dataService.datiFornitura?.get('richieste') as FormArray).at(0).get('pods') as FormArray).length > 1
      || ((this.dataService.datiFornitura?.get('richieste') as FormArray).at(0).get('pdrs') as FormArray).length > 1
    ) {
      return true;
    }
    return false;
  }

  setIbanValidators() {
    if(this.datiFattForm.get('modalitaPagamento')?.value == '0' && this.dataService.isCfStraniero$.value) {
      this.datiFattForm.get('iban')?.setValidators([Validators.required, Validators.minLength(15), Validators.maxLength(32)]);
      this.ibanMinLength = 15;
      this.ibanMaxLength = 32;
    } else {
      this.datiFattForm.get('iban')?.setValidators([Validators.required, Validators.pattern(/^(it|IT)[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/)]);
      this.ibanMinLength = null;
      this.ibanMaxLength = null;
    }

  }


  addMail() {
    (this.datiFattForm.get('mails') as FormArray).push(
      new FormControl('', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")])
    );
  }

  removeMail(id: number) {
    (this.datiFattForm.get('mails') as FormArray).removeAt(id);
  }


  // private rateizzatoCoerente(group: AbstractControl): ValidationErrors | null {
  //   const rateizzato = group.get('rateizzato')?.value;
  //   if (!rateizzato) return null;

  //   const importoAcconto = Number(group.get('importoAcconto')?.value);
  //   const prezzo = Number(group.get('prezzoPacchetto')?.value);
  //   const rate = Number(group.get('numeroRate')?.value);
  //   const importoPerRata = Number(group.get('importoPerRata')?.value);

  //   if (!rate || !importoPerRata || !importoAcconto || !prezzo) return null;

  //   const saldoResiduo = Math.round((prezzo - importoAcconto));
  //   const totaleRate = Math.round((rate * importoPerRata));

  //   if (totaleRate !== saldoResiduo) {
  //     return { rateNonCoerenti: { atteso: saldoResiduo, calcolato: totaleRate } };
  //   }
  //   return null;
  // }

  // private rateizzatoCoerente(group: AbstractControl): ValidationErrors | null {
  //   const rateizzato = group.get('rateizzato')?.value;
  //   if (!rateizzato) return null;

  //   const importoAcconto = Number(group.get('importoAcconto')?.value);
  //   const prezzoOriginale = Number(group.get('prezzoPacchetto')?.value);
  //   const sconto = Number(group.get('scontoPacchetto')?.value ?? 0);  // ← aggiunto
  //   const rate = Number(group.get('numeroRate')?.value);
  //   const importoPerRata = Number(group.get('importoPerRata')?.value);

  //   if (!rate || !importoPerRata || !importoAcconto || !prezzoOriginale) return null;

  //   // ← calcola il prezzo scontato localmente
  //   const prezzoScontato = parseFloat((prezzoOriginale * (1 - sconto / 100)).toFixed(2));
  //   const saldoResiduo = Math.round((prezzoScontato - importoAcconto) * 100) / 100;
  //   const totaleRate = Math.round((rate * importoPerRata) * 100) / 100;

  //   if (totaleRate !== saldoResiduo) {
  //     return { rateNonCoerenti: { atteso: saldoResiduo, calcolato: totaleRate } };
  //   }
  //   return null;
  // }

  get discrepanzaRate(): number | null {
    const rate = Number(this.gestioneAcconto.get('numeroRate')?.value);
    const importoPerRata = Number(this.gestioneAcconto.get('importoPerRata')?.value);
    const saldo = this.saldoResiduo;

    if (!rate || !importoPerRata || saldo === null) return null;

    const totaleRate = Math.round(rate * importoPerRata * 100) / 100;
    const diff = Math.round(Math.abs(totaleRate - saldo) * 100) / 100;

    return diff > 0 ? diff : null; // null = perfettamente coerenti, non mostrare nulla
  }

  /**
   * Azzera i campi di rateizzazione se la checkbox è attiva.
   * Chiamato quando cambia scontoPacchetto o importoAcconto.
   */
  private resetCampiRateizzazione(): void {
    if (!this.gestioneAcconto.get('rateizzato')?.value) return;

    this.gestioneAcconto.get('numeroRate')?.setValue('', { emitEvent: false });
    this.gestioneAcconto.get('importoPerRata')?.setValue('', { emitEvent: false });
    this.gestioneAcconto.get('decorrenzaDaBolletta')?.setValue('', { emitEvent: false });
    this.gestioneAcconto.get('numeroRate')?.updateValueAndValidity({ emitEvent: false });
    this.gestioneAcconto.get('importoPerRata')?.updateValueAndValidity({ emitEvent: false });
    this.gestioneAcconto.get('decorrenzaDaBolletta')?.updateValueAndValidity({ emitEvent: false });
    this.gestioneAcconto.updateValueAndValidity({ emitEvent: false });
  }

  /**
   * Unica fonte di verità per la visibilità delle sezioni.
   * Chiamata dal listener isPodMaster e dal listener pacchettoCliente.
   *
   * mostraGestionePacchetto: isPodMaster + EE + aumix SI
   * mostraGestioneAcconto:   isPodMaster + pacchetto selezionato
   */
  aggiornaVisibilita(): void {
    const isPodMaster = this.podMaster.get('isPodMaster')?.value;
    const aumixAbilitato = this.dataService.prodotto?.aumix === 'SI' || this.dataService.prodotto?.aumix === 'IMPIANTO';
    const isEE = this.dataService.prodotto?.cod_tipo_fornitura_id === 'EE';
    const hasPacchetto = !!this.gestionePacchetto.get('pacchettoCliente')?.value;

    this.mostraGestionePacchetto = isPodMaster && aumixAbilitato && isEE;
    this.mostraGestioneAcconto = isPodMaster && hasPacchetto;
  }

  displayPodMaster(value: string): string {
    if (!value || !this.podMasterOptions) return '';
    const found = this.podMasterOptions.find(opt => opt.value === value);
    return found ? found.label : value;
  }
}